module.exports = __webpack_public_path__ + "static/media/gaming4.abf70927.webp";